import { Icon } from "@iconify/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper/modules";
//import toast from "react-hot-toast";
import { Spinner } from "@chakra-ui/react";

import { useState, useEffect, useRef, useCallback } from "react";
import { formatAmountValueToString, useEstimateCost } from "./LogicHelper";

function VehicleSelectModal({
  toggleModalDisplay,
  onClose,
  selectedVehicle,
  vehicles,
  estimate,
  tripData,
  setVehicle,
  hideEstimatedCost,
  setQuoteInformation,
  setSelectedVehicle,
  errorMsgs,
  setErrorMsgs,
}) {
  // const [errorMsgs, setErrorMsgs] = useState("");
  const [quoteInfo, setQuoteInfo] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isCalculating, setIsCalculating] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const calculateEstimate = useEstimateCost(setQuoteInfo, setQuoteInformation);

  const getEstimatedCost = useCallback(
    async (event, index) => {
      if (event) event.preventDefault();
      if (!vehicles?.data?.[index]) return;

      try {
        setIsCalculating(true);
        await calculateEstimate({
          vehicle: vehicles.data[index],
          estimate,
          tripData,
        });
      } catch (error) {
        //toast.error(error.message || "Unable to get estimated cost at the moment");
      } finally {
        setIsCalculating(false);
      }
    },
    [calculateEstimate, vehicles, estimate, tripData]
  );


  useEffect(() => {
    const runEstimate = async () => {
      if (
        toggleModalDisplay &&
        vehicles?.data?.length > 0 &&
        !hasInitialized
      ) {
        const initialIndex = vehicles.data.findIndex(
          (vehicle) => vehicle.id === selectedVehicle.id
        );
        const index = initialIndex !== -1 ? initialIndex : 0;
        setActiveIndex(index);
         setHasInitialized(true);
        setErrorMsgs("");

        try {
          setIsCalculating(true);
          await calculateEstimate({
            vehicle: vehicles.data[index],
            estimate,
            tripData,
          });
          // setHasInitialized(true);
        } catch (error) {
          //toast.error(error.message || "Unable to get estimated cost at the moment");
          setErrorMsgs(error.message);
        } finally {
          setIsCalculating(false);
        }
      }
    };

    runEstimate();
  }, [
    toggleModalDisplay,
    vehicles,
    selectedVehicle?.id,
    calculateEstimate,
    estimate,
    tripData,
    hasInitialized,
    errorMsgs,
    setErrorMsgs,
  ]);

  useEffect(() => {
    if (!toggleModalDisplay) {
      setHasInitialized(false);
      //setErrorMsgs("");
    }
  }, [toggleModalDisplay, errorMsgs, setErrorMsgs]);


  useEffect(() => {
    const swiper = swiperRef.current?.swiper;
    if (swiper && swiper.activeIndex !== activeIndex) {
      swiper.slideTo(activeIndex);
    }
  }, [activeIndex]);

  // Keep parent in sync with quote info
  useEffect(() => {
    setQuoteInformation(quoteInfo);
  }, [quoteInfo, setQuoteInformation]);

  if (!toggleModalDisplay) return null;

  const handleClose = (e) => {
    if (e.target.id === "container") {
      onClose(vehicles.data[activeIndex].id);
      if (errorMsgs && errorMsgs === "Please reach out to support for interstate trips") {
        setErrorMsgs(errorMsgs)
      }
    }
  };

  const handleButtonClick = (index) => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  const handleFormStep = (e, item) => {
    e.preventDefault();
    setVehicle(item);
    setSelectedVehicle(vehicles.data[activeIndex].id);
    onClose();
  };

  return (
    <div
      onClick={handleClose}
      id="container"
      className="fixed inset-0 flex flex-col justify-center items-center py-5 px-5 md:px-0 backdrop-blur-sm font-Neue"
    >
      {
        (errorMsgs && errorMsgs === "Please reach out to support for interstate trips") ?
          (
            <div className="relative w-[90%] md:w-[70%] bg-white rounded-lg flex-column justify-content-center items-center p-10 md:p-20 border border-[#d1cece]">
              <button
                    onClick={onClose}
                    className=" flex flex-row items-center transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-80 absolute top-2 left-3"
                  >
                    <Icon icon="material-symbols:cancel-outline" width="20" height="20" />
                  </button>
              <p className="flex text-xl font-bold text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="Info">
                  <title>Info</title>
                  <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm.75 15.75h-1.5v-6h1.5v6zm0-8.25h-1.5V7.5h1.5v2z" />
                </svg>
                This trip distance falls under interstate trips</p>
              <p className="text-lg mt-4 text-slate-900 font-medium">
                Please reach out to support for interstate trips at <a href="mailto:contact@mytruq.com" className="text-gray-600 underline">contact@mytruq.com</a> or on whatsapp <a href="https://wa.me/2348144968867?text=Hello%20TruQ%20support%2C%20I%20need%20help%20with%20an%20interstate%20trip" className="text-gray-600 underline" target="_blank" rel="noopener noreferrer">+2348144968867</a>
              </p>
            </div>
          )
          :
          (<div className="relative w-full">
            {vehicles?.data?.length > 0 && (
              <div className="w-full mx-auto">
                <div className="tonnage-nav-container flex gap-x-14 sm:gap-x-36 lg:gap-x-48 px-6 py-2 md:ms-28 lg:ms-24 xl:ms-[290px] 2xl:ms-[500px]">
                  <button
                    onClick={onClose}
                    className=" flex flex-row items-center transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-80"
                  >
                    <span className="text-base pr-1 font-normal">Close</span>
                    <Icon icon="material-symbols:cancel-outline" width="16" height="17" />
                  </button>

                  <div className="flex overflow-x-auto no-scrollbar tonnage-nav">
                    <p className="me-3 my-auto text-base font-semibold text-[#232323]">
                      Vehicle Sizes
                    </p>
                    {vehicles.data.map((item, i) => (
                      <button
                        key={i}
                        className={`mx-1 p-1 border text-sm border-[#14219E] rounded ${i === activeIndex ? "bg-[#14219E] text-white" : ""
                          }`}
                        onClick={() => handleButtonClick(i)}
                      >
                        {item.tonnage}
                      </button>
                    ))}
                  </div>
                </div>


                <div ref={prevRef} className="swiper-button-prev cursor-pointer" />
                <Swiper
                  ref={swiperRef}
                  initialSlide={activeIndex}
                  freeMode={true}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onSwiper={(swiper) => {
                    setTimeout(() => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                      swiper.navigation.init();
                      swiper.navigation.update();
                    }, 0);
                  }}
                  onSlideChange={(swiper) => {
                    setActiveIndex(swiper.activeIndex);
                    getEstimatedCost(null, swiper.activeIndex);
                  }}
                  modules={[FreeMode, Pagination, Navigation]}
                  className="max-w-[100%] md:max-w-[80%] xl:max-w-[60%] bg-white border border-[#d1cece] rounded-xl"
                >

                  {vehicles.data.map((item, index) => (
                    <SwiperSlide key={index} className="overflow-y-auto no-scrollbar">
                      <div className="flex flex-col bg-white rounded-lg pt-5 md:pb-10 md:px-20 pb-5 px-10">

                        <div className="mx-auto md:mt-16 mt-20 mb-6 flex justify-center">
                          <img
                            className="mx-2 object-contain"
                            src={item.image}
                            alt="vehicles"
                            width={350}
                          />
                        </div>

                        <div className="ml-[-5px] md:ml-[-40px] md:mt-4">
                          <p className="pt-3 text-lg md:text-2xl text-[#2C3891] mb-1 font-semibold">
                            {item.category}
                          </p>
                          <p className="text-md md:text-lg text-darker md:mb-1 font-bold">Description:</p>
                          <p className="text-base text-[#333333] font-normal mt-[-5px] md:mt-0 text-justify">
                            {item.description}
                          </p>
                        </div>
                      </div>

                      <div className="mb-5 px-9 md:px-10 mt-3 flex flex-col items-end md:flex-row md:justify-between w-full md:mt-[-10px]">
                        {!hideEstimatedCost && (
                          <div>
                            <p className="text-sm md:text-base font-medium leading-snug font-Neue">
                              Estimated Cost
                            </p>
                            <h3 className="text-[#14219E] text-xl md:text-3xl font-bold font-argentum">
                              {isCalculating ? (
                                <p className="text-lg flex items-center">
                                  Calculating Estimate <Spinner color="black" className="ml-2 h-[15px] w-[15px]" />
                                </p>
                              ) : quoteInfo?.quote ? (
                                <>
                                  {quoteInfo.quote.currency}{" "}
                                  {formatAmountValueToString(quoteInfo.quote.total_charge)}
                                </>
                              ) : null}
                            </h3>
                          </div>
                        )}

                        <div
                          className={`flex ${!hideEstimatedCost ? "md:ml-auto" : "md:justify-end w-full"
                            }`}
                        >
                          <button
                            className={`w-[150px] md:w-[210px] h-10 px-10 py-4 mt-4 md:py-3 ${ isCalculating ? "bg-[#808080]" : "bg-[#14219E]"} rounded-md justify-center items-center gap-3 inline-flex md:self-end`}
                            onClick={(e) => handleFormStep(e, item)}
                            disabled={isCalculating}
                          >
                            <p className="text-white text-base font-bold leading-snug font-Neue">Select</p>
                          </button>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div ref={nextRef} className="swiper-button-next cursor-pointer" />
              </div>
            )}
          </div>)
      }
    </div>
  );
}

export default VehicleSelectModal;
